jQuery(($) => {
	$(
		"body.page-id-6553 .menu-city-changer, body.page-id-7662 .menu-city-changer"
	).on("change", "#city-changer", function () {
		const location = $(this)
			.find("option:selected")
			.text()
			.replace(" ", "-")
			.replace(",", "");
		window.location.replace(`/locations/${location.toLowerCase()}/menu`);
	});
});
